const EventEmitter = require('events');
const IdentityInfo = require('../services/identity-info');
const { Events } = require('./../constants');
const { IDENTITY_SWITCHED_CONTAINER_AT } = require('../constants/local-storage');

const emitter = new EventEmitter();

window.addEventListener(Events.STORAGE, event => {
  const affectedKey = event.key;
  if (IDENTITY_SWITCHED_CONTAINER_AT === affectedKey) {
    IdentityInfo.clearIdentitySession();
    IdentityInfo.getIdentitySession().then((userSession) => {
      const workingContainer = userSession.containerUuid;
      emitter.emit(Events.CONTAINER_CHANGED, workingContainer);
    });
  }
});

module.exports = emitter;